import { IConsuptionOptions } from '@/app/core/interfaces/consumption.interface';

export class GetCustomerPredictionAction {
  static readonly type = '[CustomerPrediction] Get Customer Prediction';
  constructor(public payload: any) {}
}

export class GetConsumptionsAction {
  static readonly type = '[customerPrediction] Get Consumptions';
  constructor(public payload: IConsuptionOptions) {}
}

export class SetSelectedGeneralFilters {
  static readonly type = '[CustomerPrediction] Set Selected General Filters';
  constructor(public payload: any[]) {}
}

export class SetSelectedGatesFilters {
  static readonly type = '[CustomerPrediction] Set Selected Gates Filters';
  constructor(public payload: any[]) {}
}

export class SetSelectedClientsFilters {
  static readonly type = '[CustomerPrediction] Set Selected Clients Filters';
  constructor(public payload: string) {}
}

export class SetMarketsFilter {
  static readonly type = '[CustomerPrediction] Set Markets Filter';
  constructor(public payload: any[]) {}
}

export class SetClientFilter {
  static readonly type = '[CustomerPrediction] Set Client Filter';
  constructor(public payload: string | null) {}
}

export class SetGatesFilter {
  static readonly type = '[CustomerPrediction] Set Gates Filter';
  constructor(public payload: any[]) {}
}

export class SetClientId {
  static readonly type = '[CustomerPrediction] Set Client Id';
  constructor(public payload: string | null) {}
}

export class ResetFilters {
  static readonly type = '[CustomerPrediction] Reset Filters';
  constructor() {}
}
